import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
//svg-icon imports
import { provideSvgIcons } from '@ngneat/svg-icon';


//local imports
import { MacdIcons } from "./macd-icons";

import {
  MacdCommonComponents,
} from "@app/macd-common";

@NgModule({
  declarations: [ MacdCommonComponents ],
  exports: [ MacdCommonComponents ],
  imports: [CommonModule],
  providers: [provideSvgIcons([...MacdIcons])],
})
export class MACDCommonModule {}
